import React from 'react';
import { COMPANY } from '../../data/company';
import { useLanguage } from '../../i18n/LanguageContext';
type LogoProps = {
  variant?: 'dark' | 'light';
};
export function Logo({
  variant = 'dark'
}: LogoProps) {
  const {
    lang
  } = useLanguage();
  const primary = variant === 'dark' ? 'text-navy' : 'text-white';
  const secondary = variant === 'dark' ? 'text-charcoal-light' : 'text-navy-100/70';
  return <span className="flex items-center gap-3" data-id="element-302" data-mp="ivol6qnya6c1">
      <span aria-hidden="true" className="flex h-10 w-10 items-center justify-center rounded-full border border-gold/60 bg-navy" data-id="element-303" data-mp="itbw7tjryvph">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true" data-id="element-304" data-mp="8wh0tjistbff">
          <path d="M2 15V5l7 5 7-5v10" stroke="#C6A257" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" data-id="element-305" data-mp="4w5i4c9zxl6l" />
        </svg>
      </span>
      <span className="leading-none" data-id="element-306" data-mp="1zapw663taih0">
        <span className={`block font-display text-xl font-semibold tracking-wide ${primary}`} data-id="element-307" data-mp="1z7k36fs2awg0">
          {COMPANY.shortName}
        </span>
        <span className={`block text-[9px] font-semibold uppercase tracking-widest2 ${secondary}`} data-id="element-308" data-mp="1j7c3bdjiauvm">
          {COMPANY.descriptor[lang]} S.L.
        </span>
      </span>
    </span>;
}